import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=bc0f9240&scoped=true"
import script from "./userMessage.vue?vue&type=script&lang=js"
export * from "./userMessage.vue?vue&type=script&lang=js"
import style0 from "./userMessage.vue?vue&type=style&index=0&id=bc0f9240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0f9240",
  null
  
)

export default component.exports